import {
    SET_LOGIN_MODAL_STEP, SET_SELL_EVENTS, SET_SELL_TICKETS, TOGGLE_TICKET_SELECTION, SELECT_ALL_TICKETS,
    DESELECT_ALL_TICKETS,
} from '../actions/sell-tickets';
import {
    ADD_ITEM_FORM, CHANGE_FORM_BY_INDEX, DELETE_ITEM_FORM, SET_FORM_DATA, SET_FORM_BY_ID,
    SET_SELL_FORM_FIELD_ERROR_MESSAGE, SET_SELL_FORM_FIELD_VALUE, SET_SELL_FORM_FIELD_VISIBILITY,
    SET_HAS_MULTIPLE_EVENTS,
} from '../actions/forms';
import {
    BANK_ACCOUNT_FORM, BANK_ACCOUNT_INITIAL_STATE, SALE_OPTIONS_FORM, SALE_OPTIONS_INITIAL_STATE, SELL_TICKET_FORM,
    TICKET_CODES_FORM,
} from './features';

const INITIAL_STATE = {
    step: null,
    user: { email: '', password: '', error: '' },
    events: [],
    event: {},
    tickets: [],
    hasMultipleEvents: false,
    forms: {
        [SELL_TICKET_FORM]: {},
        [BANK_ACCOUNT_FORM]: { ...BANK_ACCOUNT_INITIAL_STATE },
        [SALE_OPTIONS_FORM]: { ...SALE_OPTIONS_INITIAL_STATE },
        [TICKET_CODES_FORM]: [{ code: '' }],
    },
};

export const sellTicketsUiReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_LOGIN_MODAL_STEP:
            return {
                ...state,
                step: action.payload,
            };
        case SET_SELL_EVENTS:
            return {
                ...state,
                events: action.payload,
            };
        case SELECT_ALL_TICKETS:
            return {
                ...state,
                tickets: state.tickets.map((ticket) => ({ ...ticket, isSelected: true })),
            };
        case DESELECT_ALL_TICKETS:
            return {
                ...state,
                tickets: state.tickets.map((ticket) => ({ ...ticket, isSelected: false })),
            };
        case SET_SELL_TICKETS:
            return {
                ...state,
                tickets: action.payload.tickets,
                event: action.payload.event,
            };
        case TOGGLE_TICKET_SELECTION:
            return {
                ...state,
                tickets: state.tickets.map((ticket) => (ticket.code === action.payload
                    ? {
                        ...ticket,
                        isSelected: !ticket.isSelected,
                    } : ticket)),
            };
        case SET_FORM_DATA:
            return {
                ...state,
                forms: {
                    ...state.forms,
                    [action.form]: {
                        ...action.data,
                    },
                },
            };
        case SET_FORM_BY_ID:
            return {
                ...state,
                forms: {
                    ...state.forms,
                    [action.form]: {
                        ...state.forms[action.form],
                        [action.id]: {
                            ...state.forms[action.form][action.id],
                            ...action.value,
                        },
                    },
                },
            };
        case ADD_ITEM_FORM:
            return {
                ...state,
                forms: {
                    ...state.forms,
                    [action.form]: [...state.forms[action.form], action.value],
                },
            };
        case CHANGE_FORM_BY_INDEX:
            return {
                ...state,
                forms: {
                    ...state.forms,
                    [action.form]: state.forms[action.form].map((item, index) => ((index === action.index) ? action.value : item)),
                },
            };
        case DELETE_ITEM_FORM:
            return {
                ...state,
                forms: {
                    ...state.forms,
                    [action.form]: state.forms[action.form].filter((_, index) => index !== action.index),
                },
            };
        case SET_SELL_FORM_FIELD_VALUE:
            return {
                ...state,
                forms: {
                    ...state.forms,
                    [action.form]: {
                        ...state.forms[action.form],
                        [action.field]: {
                            ...state.forms[action.form][action.field],
                            value: action.value,
                            isValid: true,
                            errorMessage: null,
                        },
                    },
                },
            };
        case SET_SELL_FORM_FIELD_ERROR_MESSAGE:
            return {
                ...state,
                forms: {
                    ...state.forms,
                    [action.form]: {
                        ...state.forms[action.form],
                        [action.field]: {
                            ...state.forms[action.form][action.field],
                            errorMessage: action.errorMessage,
                        },
                    },
                },
            };
        case SET_SELL_FORM_FIELD_VISIBILITY:
            return {
                ...state,
                forms: {
                    ...state.forms,
                    [action.form]: {
                        ...state.forms[action.form],
                        [action.field]: {
                            ...state.forms[action.form][action.field],
                            isVisible: action.isVisible,
                        },
                    },
                },
            };
        case SET_HAS_MULTIPLE_EVENTS:
            return {
                ...state,
                hasMultipleEvents: action.hasMultipleEvents,
            };
        default:
            return state;
    }
};

export default sellTicketsUiReducer;
